/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
import * as Permission from '../util/Permission';

export default declareEntity({
    entity: "profileDefs",
    graphQL: "ProfileDef",
    name: "Profile Definition",
    dynamoPrefix: 'def',
    storageType: 'schema',
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    defaultOrder: ['name', 'key'],
    defaultTitle: (data) => {
        return data['name'];
    },
    isPublic: true,
    fields: (types) => { return {
        id: {
            name: "Profile Definition ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            isPublic: true,
        },
        name: {
            name: "Name",
            trim: true,
            type: "string",
            translatable: true,
            defaultValue: "",
            required: true,
            filterable: true,
            isPublic: true,
        },
        key: {
            name: "Key",
            trim: true,
            type: "string",
            defaultValue: "com.dativery.profiles.xxx",
            required: true,
            validations: {
                matchRegexp: /^[a-zA-Z0-9\.\-]+$/,
            }
        },
        primaryEntityKey: {
            name: "Primary Entity Definition",
            type: "string",
            required: true,
        },
        primaryEntityDef: {
            name: "Metadata",
            type: "relation",
            to: () => types['entityDefs'],
            userEditable: false,
            import: false,
            export: false,
            controllerFn: "getPrimaryEntyDef",
        },
        parentProfileDef: {
            name: "Parent Profile Definition",
            to: () => types['profileDefs'],
            defaultValue: (groupDef) => {
                return groupDef['profileDef_id'];
            },
            type: "relation",
        },
        description: {
            name: "Description",
            type: "text",
            translatable: true,
            defaultValue: ""
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
        profileItemDefs: {
            type: 'oneToMany',
            to: types['profileItemDefs'],
            export: true,
            defaultValue: () => {
                return {};
            },
        }
    }; }

});
